import React from 'react';
import styled from 'styled-components';

import {
  Box,
  Paragraph,
  Accordion as GrommetAccordion,
  AccordionPanel as GrommetAccordionPanel,
} from 'grommet';

import { Player as ReactPlayer } from 'video-react';

const AccordionBookElement = styled(GrommetAccordion)`
  width: 100%;
  max-width: 600px;
  display: block;
  overflow: visible;
  min-height: initial;
`;

const AccordionPanel = styled(GrommetAccordionPanel)`
  height: 40px;
`;

const AccordionContent = styled(Box)`
  max-height: 150px;
  max-width: 600px;
  overflow-y: auto;
  box-shadow: 0px 2px 4px rgba(100, 100, 100, 0.5) inset;
  padding: 0 6px;
`;

const Player = styled(ReactPlayer)`
  max-width: 600px !important;
  font-family: inherit !important;
`;

const Container = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 12px 0;
`;

function MediaClip({ path, content }) {
  return (
    <Container margin="vertical">
      <Player
        aria-label="media clip"
        alt={content.caption}
        poster={require('../../../content' + content.poster)}
      >
        <source src={require('../../../content' + content.source)} />
      </Player>
      {content.transcript && (
        <AccordionBookElement animate={false}>
          <AccordionPanel background="light-4" label="transcript">
            <AccordionContent>
              <div>
                <Paragraph>{content.transcript}</Paragraph>
              </div>
            </AccordionContent>
          </AccordionPanel>
        </AccordionBookElement>
      )}
    </Container>
  );
}

export default MediaClip;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/MediaClip.js